import { Component, OnDestroy, OnInit } from '@angular/core';
import { CardInputsAbstractInput } from '../card-inputs.abstract-input';
import { FormControl, Validators } from '@angular/forms';

@Component({
    'selector': 'card-inputs-holder-name',
    'templateUrl': './card-inputs.holder-name.component.html',
    'providers': [],
    'styleUrls': []
})
export class CardInputsHolderNameComponent extends
    CardInputsAbstractInput implements OnInit, OnDestroy {

    ngOnInit() {
        this.form.addControl('holder_name', this.control = new FormControl(
            '',
            [Validators.required]
        ));
    }
    
    ngOnDestroy() {
        this.form.removeControl('holder_name');
    }

    emitKeyUp(){
        const fieldId   = 'card-name-' + this.index + '-' + this.cardIndex;
        const $field    = document.getElementById(fieldId) as HTMLInputElement;;

        if ($field) {
            const valor = $field.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            const regex = /^[a-zA-Z0-9\s]+$/;
    
            if (!regex.test(valor)) {
                $field.value = valor.slice(0, -1);
            }
            
            $field.value = valor;
        }
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/card-inputs/holder-name/card-inputs.holder-name.component.ts